import {
  FormControl, InputLabel, MenuItem, SelectChangeEvent,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomSelect from '../../../../components/CustomSelect';
import { BILLING } from '../../../../consts/enums';
import STRING_KEYS from '../../../../language/keys';
import { style } from './style';

type AccountBillingTypeSelectorProps = {
  billing: string,
  viewMode: ViewMode,
  onValuesChange: (name: string, value: string) => void,
  isEditable: boolean,
}
export const AccountBillingTypeSelector = ({
  billing,
  viewMode,
  onValuesChange,
  isEditable,
}: AccountBillingTypeSelectorProps):JSX.Element => {
  const { t: translate } = useTranslation();

  const menuBilling = [
    {
      title: translate(STRING_KEYS.BILLING_MENU.ONE_YEAR),
      type: BILLING.ANNUALLY,
    },
    {
      title: translate(STRING_KEYS.BILLING_MENU.QUARTERLY),
      type: BILLING.QUARTERLY,
    },
    {
      title: translate(STRING_KEYS.BILLING_MENU.MONTHLY),
      type: BILLING.MONTHLY,
    },
  ];

  const renderMenu = ():React.ReactNode => {
    return menuBilling.map((item: {
      title: string,
      type: string,
    }) => {
      return (
        <MenuItem
          key={ item.title }
          value={ item.type }
        >
          {item.title}
        </MenuItem>
      );
    });
  };
  
  return (
    <FormControl
      fullWidth
      variant={ isEditable ? 'outlined' : 'standard' }
      margin="normal"
    >
      <InputLabel id="billing" sx={ style.label.sx }>
        {translate(STRING_KEYS.BILLING_CYCLE)}
      </InputLabel>
      <CustomSelect
        labelId="billing"
        value={ billing }
        viewMode={ viewMode }
        name="billing"
        label={ translate(STRING_KEYS.BILLING_CYCLE) }
        onChange={ (e:SelectChangeEvent<unknown>) => {
          onValuesChange('billing', e.target.value as string);
        } }
      >
        {renderMenu()}
      </CustomSelect>
    </FormControl>
  );
};
